import { useConnectedClient } from 'context/ConnectedClientContext';

export const useIndustryStreamAccess = (): boolean => {
  const { details } = useConnectedClient();

  return Boolean(details?.ConnectedTeam?.products?.features?.industry_stream?.enabled);
};
